import React, { useEffect } from "react";
import success from "../../../assets/images/success.svg";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { WalletMA } from "boa-sdk-ts";

const SuccessFullTran = (props) => {
  useEffect(() => {
    console.log("SuccessFullTransaction:CheckBalance");
    WalletMA.instance().accounts.checkBalance();
  }, []);
  return (
    <>
      <div className="Content">
        <div className="TableBg cardBg mh">
          <div className="SuccessBg">
            <div>
              <h1 className="text-center d-block SuccessTitle">
                {props.i18n.t("Transaction_has_been_successful")}
              </h1>
              <div className="success_img">
                <img
                  alt="success"
                  className="img-fluid mx-auto d-block"
                  src={success}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(withTranslation()(SuccessFullTran));
